import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  items: {},
  pending: false,
  error: null,
};

const getToDoList = createAsyncThunk('todoList/getToDoList', async (params) => {
  // NOTE: be sure the constant name matches exactly
  return application.call(API.ORGANIZATION.GET_TO_DO_LIST, params);
});

function onGetToDoList(state, action) {
  const payload = action.payload;
  // handle both: {result: {...}} or just {...}
  const result = payload && payload.result ? payload.result : payload || {};

  Object.assign(state, {
    items: result,
    pending: false,
    error: null,
  });
}

export const actions = {
  getToDoList,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(getToDoList.pending, (state) => {
      state.pending = true;
      state.error = null;
    })
    .addCase(getToDoList.fulfilled, onGetToDoList)
    .addCase(getToDoList.rejected, (state, action) => {
      state.pending = false;
      state.error = action.error?.message || 'Failed to load To-Do list';
    });
});
